import { v5 as uuidv5 } from 'uuid';

import { CheckCircle } from '@mui/icons-material';

import { ContractDocumentAllowedContentType } from '@octopus/api';

import { SnackbarType } from '../../../../modules/hooks/snackbarContext';

import { ALLOWED_CONTENT_TYPES } from './types';

const NAMESPACE = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';

export const getIdentifierFromCPF = (cpf: string): string => {
  return uuidv5(cpf, NAMESPACE);
};

export const getErrorSnackbar = (message?: string): SnackbarType => ({
  isOpen: true,
  variant: 'error',
  Message: message || 'Ocorreu um erro, por favor tente novamente.',
  hasCloseAction: true,
});

export const getSuccessSnackbar = (message: string): SnackbarType => ({
  isOpen: true,
  variant: 'default',
  Message: message,
  StartAdornment: <CheckCircle />,
  autoHideDuration: 2000,
  hasCloseAction: false,
});

export const getContentType = (
  file: File,
): ContractDocumentAllowedContentType => {
  const extension = `.${file.name.split('.').pop()?.toLowerCase()}`;
  return ALLOWED_CONTENT_TYPES[extension] || 'application/pdf';
};
